import { Box, BoxProps } from '@mui/material'
import React from 'react'
interface Props extends BoxProps {

}
const StickyBar:ReactFC<Props> = ({ children, sx, ...restProps }) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        paddingTop: '10px',
        zIndex: 100,
        bgcolor: 'background.default',
        ...sx
      }}
      {...restProps}
    >
      {children}
    </Box>
  )
}
export default StickyBar
